import { translate } from "app/filters/i18nFilter";
import { ERROR_PROJECT_LIST_SRC } from "app/pages/activation/components/ProjectsList/constants";
import { statesDataAutomation } from "app/pages/activation/components/ProjectsList/dataAutomationKeys";
import * as SC from "app/pages/activation/components/ProjectsList/States/styles";
import {
    ERROR_PROJECT_LIST_DESCRIPTION,
    ERROR_PROJECT_LIST_TITLE,
} from "app/pages/activation/components/ProjectsList/States/texts";
import { AssetsService } from "app/services/AssetsService";

export const ErrorState = () => (
    <SC.Container data-automation={statesDataAutomation.error}>
        <SC.ErrorImage src={AssetsService.assetUrl(ERROR_PROJECT_LIST_SRC)} />
        <SC.Content>
            <SC.Title>{translate(ERROR_PROJECT_LIST_TITLE)}</SC.Title>
            <SC.Description>{translate(ERROR_PROJECT_LIST_DESCRIPTION)}</SC.Description>
        </SC.Content>
    </SC.Container>
);
